import { Link } from 'react-router-dom';

import code from '../../assets/images/footer/code.png'

import styles from './style.module.scss'

import { TOOLS } from 'constantss';

export const Footer = () => {
    return (
        <footer  className={styles['footer']}>
            <div  className={styles['footer-container']}>
                <div  className={styles['footer-item']}>
                    <p>热门推荐</p>
                    <p><Link target='_blank' to="/solution?module=NetworkSafety">网络安全</Link></p>
                    <p><Link target='_blank' to="/solution?module=SmartPolicing">智慧警务</Link></p>
                    <p><Link target='_blank' to="/solution?module=SmartGovernment">智慧政务</Link></p>
                    <p><Link target='_blank' to="/solution?module=DigitalTransformation">企业数字化转型</Link></p>
                    {/* <p onClick={() => {
                        window.open(TOOLS.URL, '_blank')
                    }}>应用开发工具集</p> */}
                </div>
                <div  className={styles['footer-item']}>
                    <p>关于星空</p>
                    <p><Link target='_blank' to="/about">公司简介</Link></p>
                    <p><Link target='_blank' to="/support">服务体系</Link></p>
                </div>
                <div  className={styles['footer-item']}>
                    <p>联系我们</p>
                    <p>客服电话：400-110-0111</p>
                    <p>总部地址：南京市建邺区云龙山路88号烽火科技大厦</p>

                </div>
                <div  className={styles['footer-item']}>
                    <p>关注星空</p>
                    <p>随时了解最新动态</p>
                    <p><img src={code} alt="" /></p>
                </div>
            </div>
            <div  className={styles['footer-copyright']}>
                Copyright©2019-2023 南京烽火星空发展有限公司  <a href='https://beian.miit.gov.cn'>苏ICP备11014881号-9</a>
            </div>
        </footer>
    )
}